var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSkiFreeride(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.143 11.25l11.2 7.822 1.6-.177m-6.844-4.089l4.622-1.334-2.222-3.555 4.088-.89 3.023 3.557h-3.556m-2.933-.178H7.788m11.1-4.317a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-3.545.139l-4.622-2.312m2.222 2.667L8.232 6.005m3.2 3.645l-5.6-3.111",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })));
}

export default SvgIconSkiFreeride;